require('select2');
require("select2/dist/js/i18n/es.js");
require("select2/dist/js/i18n/eu.js");
require("select2/dist/js/i18n/ca.js");
require("select2/dist/js/i18n/gl.js");
